import React from "react";

const withFormikField = Component => {
  return ({ field, ...props }) => {
    const { form, label, ...other } = props;
    const { errors, touched } = form;
    const fieldError = errors[field.name];
    const fieldTouched = touched[field.name];
    const error = fieldError && fieldTouched ? true : false;

    return (
      <Component
        {...field}
        {...other}
        error={error}
        label={error ? fieldError : label}
      />
    );
  };
};

export default withFormikField;
